import { useQuery } from '@tanstack/react-query';
import getAllTRSRegistrationsByCompanyId from '@/API/TRSRegistration/getTRSRegistrationsByCompanyId';

const useGetAllTRSRegistrations = (currentScope, currentCompany) => {
    return useQuery({
        queryKey: ['TRSRegistrations Available', currentCompany],
        queryFn: () => {
            const data = getAllTRSRegistrationsByCompanyId(
                currentScope,
                currentCompany,
            );
            return data;
        },
        refetchOnWindowFocus: false,
        staleTime: 0,
        cacheTime: 0,
        enabled: !!currentCompany,
        retry: 3,
    });
};

export default useGetAllTRSRegistrations;
